<div class="row">
  <div class="col-md-6">
    <div class="card card-primary">
      <form #voyageEntry="ngForm" class="form-horizontal"
        (ngSubmit)="saveVoyage()">
        <div class="card-body">
          <div class="form-group row">
            <app-material-auto-complete
              class="col-md-6"
              name="vessel"
              id="vessel"
              [formatter]="vesselFormatter"
              [(ngModel)]="selectedVessel"
              [items]="vessels"
              [placeholder]="'Vessel'"
              [required]="true">
            </app-material-auto-complete>
          @if (selectedVessel !== undefined && selectedVessel.previousNames.length > 0) {
            <app-material-auto-complete
              class="col-md-6"
              name="vesselName"
              [items]="selectedVessel.previousNames"
              [formatter]="vesselNameFormatter"
              [(ngModel)]="vesselOldName"
              [placeholder]="'Old Name'">
            </app-material-auto-complete>
          }
          </div>
          <div class="form-group row">
            <app-material-pg-input
              label="Ship VN"
              id="shipVoyageNumber"
              name="shipVoyageNumber"
              type="text"
              [(ngModel)]="selectedVoyage.shipVoyageNo"
              [required]="true">
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="Agent VN"
                id="agentVoyageNumber"
                name="agentVoyageNumber"
                type="text"
                [(ngModel)]="selectedVoyage.agentVoyageNo"
                [required]="true">
            </app-material-pg-input>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button
                mat-raised-button
                mat-stroked-button
                type="submit"
                id="submit"
                class="pull-right"
                [disabled]="!voyageEntry.form.valid">Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
